import React, { useEffect } from 'react';
import { Analytics } from '@trello/atlassian-analytics';
import { forTemplate } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { ProductKeys } from '@atlassiansox/product-store-react';
import { UtmCampaign } from 'app/gamma/src/util/cross-flow-essentials';
import {
  OverlayType,
  setOverlay,
} from 'app/gamma/src/modules/state/ui/overlay';

import { defaultStore } from 'app/gamma/src/defaultStore';
import styles from './ConfluenceCrossflowBanner.less';

const illustrationSrc = require('resources/images/confluence-crossflow/illustration.png');
const confluenceSrc = require('resources/images/confluence-crossflow/confluence-logo.svg');

const format = forTemplate('directory_crossflow');

export interface ConfluenceCrossflowBannerProps {
  boardId?: string;
}
export const ConfluenceCrossflowBanner: React.FunctionComponent<ConfluenceCrossflowBannerProps> = ({
  boardId,
}) => {
  const analyticContainers = boardId ? { board: { id: boardId } } : undefined;

  useEffect(() => {
    Analytics.sendUIEvent({
      action: 'viewed',
      actionSubject: 'banner',
      actionSubjectId: 'confluenceLearnMoreBanner',
      source: 'boardDirectoryFeaturedScreen',
      containers: analyticContainers,
    });
  }, [analyticContainers]);

  const openOverlay = () => {
    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'confluenceLearnMoreButton',
      source: 'boardDirectoryFeaturedScreen',
      containers: analyticContainers,
    });
    defaultStore.dispatch(
      setOverlay({
        overlayType: OverlayType.ProductStore,
        productKey: ProductKeys.CONFLUENCE,
        context: {
          source: 'try',
          campaign: UtmCampaign.TOUCHPOINTS_CONFLUENCE_POWERUPS,
        },
      }),
    );
  };
  return (
    <div className={styles.confluenceCrossflowBannerContainer}>
      <div className={styles.confluenceCrossflowBanner}>
        <div className={styles.floatingText}>{format('featured-product')}</div>
        <img src={illustrationSrc} className={styles.illustration} alt="" />
        <div className={styles.copyContainer}>
          <h1 className={styles.bannerHeading}>
            <img
              alt="Confluence"
              src={confluenceSrc}
              className={styles.confluenceLogo}
            />
          </h1>
          <p className={styles.bannerParagraph}>
            {format('confluence-crossflow-description')}
          </p>
        </div>
        <div className={styles.ctaContainer}>
          <PrimaryButton onClick={openOverlay}>
            {format('confluence-button-text')}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};
